import Grid from '@mui/material/Grid';
import { HelpfulQuestion } from '@buoy-components/user-feedback';
import { trackStructuredEvent } from 'src/analytics';
import { getCategory } from 'src/interviews/analytics';
import useInterview from 'src/interviews/hooks/useInterview';

import type { IInterviewResults } from 'src/packages/polaris/types';

function Helpfulness({ result }: { result: IInterviewResults }) {
  const interview = useInterview();

  return (
    <Grid item className="bp-mb-0 [&_.MuiButton-textPrimary]:bp-bg-primary-main">
      <HelpfulQuestion
        snowplowProps={{
          action: getCategory('dxoc'),
          label: interview.token || '',
        }}
        trackingCallback={trackStructuredEvent}
        withBuoyTheme
      />
    </Grid>
  );
}

export default Helpfulness;
